/**
 * Birthday Dress — US shipping delay notice (DEBUG VERSION)
 * Product: Plunging Knot Detail Gown with Fringing - Black
 * Product ID: 15048130888045
 *
 * This is a temporary debug build of the script — it logs to the console
 * at every key step so we can see exactly where things are breaking.
 * Once everything's confirmed working, swap back to a clean version
 * without the console.log lines (or just leave them, they're harmless).
 *
 * HOW TO TEST:
 *   1. Replace the contents of your existing birthday-dress-cart-notice.js
 *      asset file with this version. Save.
 *   2. Open the live storefront, open DevTools > Console, refresh the page.
 *   3. You should immediately see "[BirthdayDress] script loaded".
 *      If you DON'T see this, the file still isn't loading — screenshot
 *      the Console tab as-is.
 *   4. Add the dress to cart. Watch the console — it will log the
 *      add-to-cart request, what product ID it saw, and whether it matched.
 *   5. Open the cart drawer. It will log the cart contents, whether the
 *      dress was found, and whether it found the drawer element to attach
 *      the banner to.
 *   6. Screenshot the full console output after doing steps 4-5 and send
 *      it over.
 */
(function () {
  "use strict";

  console.log("[BirthdayDress] script loaded");

  // ---- CONFIG: edit these ----
  // Live US store product ID for the Plunging Knot Detail Gown with
  // Fringing - Black.
  var BIRTHDAY_DRESS_PRODUCT_ID = 15048130888045;

  // These two now contain a little inline HTML (<strong> tags) so parts
  // of the copy can render bold. Keep any future edits to plain text +
  // <strong>...</strong> only — the code below renders these as HTML.
  var POPUP_MESSAGE =
    "<strong>PLEASE NOTE</strong> - The Plunging Knot Detail Gown with Fringing will ship from <strong>August 5th</strong>.";

  var CART_BANNER_MESSAGE =
    "<strong>PLEASE NOTE</strong> - The Plunging Knot Detail Gown with Fringing will ship from <strong>August 5th</strong>. The remainder of your order will follow our usual dispatch times.";

  // Update this to match your theme's actual cart drawer wrapper.
  var CART_DRAWER_SELECTOR =
    "#CartDrawer, .cart-drawer, #cart-drawer, [data-cart-drawer], cart-drawer";
  // ---- end config ----

  var POPUP_ID = "birthday-dress-popup";
  var BANNER_ID = "birthday-dress-cart-banner";

  /* ---------- 1. Pop-up on add-to-cart ---------- */

  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === "string" ? input : (input && input.url) || "";
    var isAddToCart = url.indexOf("/cart/add") !== -1;

    if (isAddToCart) {
      console.log("[BirthdayDress] detected add-to-cart request:", url);
    }

    return originalFetch.apply(this, arguments).then(function (response) {
      if (isAddToCart) {
        response
          .clone()
          .json()
          .then(function (data) {
            console.log("[BirthdayDress] add-to-cart response data:", data);

            var items = data && data.items ? data.items : [data];
            var matched = items.some(function (item) {
              return item && item.product_id === BIRTHDAY_DRESS_PRODUCT_ID;
            });

            console.log(
              "[BirthdayDress] product IDs in response:",
              items.map(function (i) {
                return i && i.product_id;
              }),
              "| looking for:",
              BIRTHDAY_DRESS_PRODUCT_ID,
              "| matched:",
              matched
            );

            if (matched) {
              console.log("[BirthdayDress] showing popup");
              showPopup();
            }
          })
          .catch(function (err) {
            console.log(
              "[BirthdayDress] could not parse add-to-cart response as JSON:",
              err
            );
          });
      }
      return response;
    });
  };

  function showPopup() {
    if (document.getElementById(POPUP_ID)) return;

    var overlay = document.createElement("div");
    overlay.id = POPUP_ID;
    overlay.style.cssText =
      "position:fixed;inset:0;background:rgba(0,0,0,0.5);" +
      "z-index:99999;display:flex;align-items:center;justify-content:center;" +
      "padding:16px;";

    overlay.innerHTML =
      '<div style="background:#fff;max-width:420px;width:100%;padding:28px 24px;' +
      'border-radius:0;text-align:center;font-family:inherit;">' +
      '<p style="margin:0 0 20px;font-size:15px;line-height:1.6;text-align:center;">' +
      POPUP_MESSAGE +
      "</p>" +
      '<button type="button" id="' +
      POPUP_ID +
      '-close" style="display:block;margin:0 auto;padding:11px 28px;' +
      'border:none;background:#000;color:#fff;border-radius:0;' +
      'cursor:pointer;font-size:13px;letter-spacing:0.05em;' +
      'text-transform:uppercase;">Got it</button>' +
      "</div>";

    document.body.appendChild(overlay);

    document
      .getElementById(POPUP_ID + "-close")
      .addEventListener("click", function () {
        overlay.remove();
      });
    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) overlay.remove();
    });
  }

  /* ---------- 2. Banner inside the cart drawer ---------- */

  function refreshBanner() {
    fetch("/cart.js")
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var hasDress = cart.items.some(function (item) {
          return item.product_id === BIRTHDAY_DRESS_PRODUCT_ID;
        });

        console.log(
          "[BirthdayDress] cart check — product IDs currently in cart:",
          cart.items.map(function (i) {
            return i.product_id;
          }),
          "| looking for:",
          BIRTHDAY_DRESS_PRODUCT_ID,
          "| hasDress:",
          hasDress
        );

        var existing = document.getElementById(BANNER_ID);

        if (hasDress && !existing) {
          insertBanner();
        } else if (!hasDress && existing) {
          console.log("[BirthdayDress] removing banner, dress no longer in cart");
          existing.remove();
        }
      })
      .catch(function (err) {
        console.log("[BirthdayDress] could not fetch /cart.js:", err);
      });
  }

  // Finds the on-page element most likely to represent a price amount
  // (e.g. "$40.00"), by scanning for leaf elements whose text matches a
  // currency pattern. Returns the LAST match in document order, which in
  // a cart drawer is typically the order total (bottom of the list) —
  // used as the right-alignment reference so our banner's right edge
  // matches the price column rather than a full-width checkout button.
  function findPriceReferenceElement(root) {
    var CURRENCY_PATTERN = /^[£$€]\s?\d{1,3}(,\d{3})*(\.\d{2})?$/;
    var all = root.querySelectorAll("*");
    var match = null;
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.children.length === 0 && CURRENCY_PATTERN.test(el.textContent.trim())) {
        match = el;
      }
    }
    return match;
  }

  function insertBanner() {
    var drawer = document.querySelector(CART_DRAWER_SELECTOR);
    console.log(
      "[BirthdayDress] looking for cart drawer with selector:",
      CART_DRAWER_SELECTOR,
      "| found:",
      drawer
    );
    if (!drawer) {
      console.log(
        "[BirthdayDress] no drawer element found — CART_DRAWER_SELECTOR needs updating"
      );
      return;
    }

    var banner = document.createElement("div");
    banner.id = BANNER_ID;
    // Styled as a contained box (matching the light notice boxes used on
    // product pages, e.g. "order within X to receive by Y") rather than a
    // full-width strip. Tweak background/text colors, font, and radius
    // below to match the exact brand values if these don't line up.
    banner.style.cssText =
      "background:#f5f4f2;color:#1a1a1a;padding:12px 16px;" +
      "font-size:13px;line-height:1.4;text-align:left;" +
      "border-radius:0;box-sizing:border-box;" +
      "align-self:flex-start;justify-self:start;";
    banner.innerHTML = CART_BANNER_MESSAGE;

    // Anchor point: the native Shopify checkout button always has
    // name="checkout" (required for the cart form to submit to checkout),
    // so this works regardless of the theme's specific class names.
    // We insert the banner immediately before the block that contains the
    // totals + checkout button, so it sits just above "Total" rather than
    // at the very top of the drawer.
    var checkoutButton = drawer.querySelector('[name="checkout"]');
    console.log("[BirthdayDress] checkout button found:", checkoutButton);

    if (checkoutButton) {
      // Walk up to find the wrapping footer block (totals + button
      // together), falling back to the button's direct parent if no
      // obvious "footer" wrapper is found.
      var footer =
        checkoutButton.closest(
          '[class*="footer"], [id*="footer"], [class*="Footer"]'
        ) || checkoutButton.parentElement;
      footer.parentElement.insertBefore(banner, footer);
      console.log("[BirthdayDress] banner inserted above footer/checkout area");

      // LEFT edge: plain 0 margin — this is what actually matched the
      // product images exactly (the container's own built-in padding
      // already lines everything up).
      // RIGHT edge: measured against an actual price amount (e.g.
      // "$40.00"), since the checkout button is wider than the price text.
      var referencePrice = findPriceReferenceElement(drawer);
      var parentRect = banner.parentElement.getBoundingClientRect();

      var leftInset = 0;
      var rightInset = referencePrice
        ? Math.max(0, parentRect.right - referencePrice.getBoundingClientRect().right)
        : Math.max(0, parentRect.right - footer.getBoundingClientRect().right);

      console.log(
        "[BirthdayDress] reference price element:",
        referencePrice,
        referencePrice ? referencePrice.textContent.trim() : null
      );
      banner.style.marginLeft = leftInset + "px";
      banner.style.marginRight = rightInset + "px";
      banner.style.marginTop = "12px";
      banner.style.marginBottom = "12px";
      banner.style.width = "auto";
      console.log(
        "[BirthdayDress] aligned banner to footer bounds — leftInset:",
        leftInset,
        "rightInset:",
        rightInset
      );
    } else {
      // Fallback: couldn't find the checkout button for some reason —
      // insert at the top of the drawer instead so the message still shows.
      drawer.insertBefore(banner, drawer.firstChild);
      console.log(
        "[BirthdayDress] fallback: inserted at top of drawer (checkout button not found)"
      );
    }
  }

  // The click+timeout check below is a fallback for the very first time
  // the drawer opens. It's NOT reliable for keeping the banner correct
  // over time: if a second product gets added after the dress, the
  // theme re-renders the drawer's contents from scratch (to show the new
  // item), which wipes out our banner element along with everything else.
  // A fixed timeout can't know when that re-render has actually finished.
  //
  // The MutationObserver below is the real fix: it watches the drawer's
  // contents directly and re-runs refreshBanner() any time the drawer's
  // DOM changes for ANY reason (item added, removed, quantity changed,
  // etc.), so the banner reliably reappears no matter what order items
  // are added in.
  function setupDrawerObserver() {
    var drawer = document.querySelector(CART_DRAWER_SELECTOR);
    if (!drawer) {
      // Drawer element may not exist in the DOM yet on some themes —
      // keep checking until it does.
      setTimeout(setupDrawerObserver, 500);
      return;
    }

    var debounceTimer = null;
    var observer = new MutationObserver(function () {
      // Debounced: a single cart update can trigger many small DOM
      // mutations in quick succession, we only want to react once.
      // This is safe from infinite loops — once the banner matches
      // the cart's actual state, refreshBanner() makes no further DOM
      // changes, so no further mutation fires and the chain stops.
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(refreshBanner, 150);
    });

    observer.observe(drawer, { childList: true, subtree: true });
    console.log("[BirthdayDress] MutationObserver attached to cart drawer");
  }

  document.addEventListener("click", function () {
    setTimeout(refreshBanner, 300);
  });
  document.addEventListener("DOMContentLoaded", function () {
    refreshBanner();
    setupDrawerObserver();
  });

  // Also run once immediately in case DOMContentLoaded already fired
  // before this script executed (e.g. if loaded with `defer`).
  if (document.readyState !== "loading") {
    refreshBanner();
    setupDrawerObserver();
  }
})();